import { newRegBusReducer } from "../reducer/NewRegBusReducer";

export const reducer = newRegBusReducer;
